import PostApi from '@/postApi';
// import common from '@/util/common';
export default {
	namespaced: true,
	state: {
		
	},
	actions: {
		async login({commit},param) {
			console.log(param)
			const login = await PostApi.login(param);
			console.log(commit);
			return login;
		},
		async getConf({commit},param) {
			const getConfData = await PostApi.getConf(param);
			console.log('getConfData',commit,getConfData);
			return getConfData;
		},
		async postWxLogin({commit},param) {
			const getWxLoginData = await PostApi.postWxLogin(param);
			console.log('getWxLoginData',commit,getWxLoginData);
			return getWxLoginData;
		},
		async postRedirect({commit},param) {
			const getRedirectData = await PostApi.postRedirect(param);
			console.log('getRedirectData',commit,getRedirectData);
			return getRedirectData;
		},
		async bankAutoLogin({commit},param) {
			const getBankAutoLoginData = await PostApi.bankAutoLogin(param);
			console.log('getBankAutoLoginData',commit,getBankAutoLoginData);
			return getBankAutoLoginData;
		},
	},
	mutations: {
	},
}
